import React from 'react';
import { motion } from 'framer-motion';
import { HeroContentLayout } from './layout/HeroContentLayout';
import HeroHeadline from './HeroHeadline';
import HeroSubheadline from './HeroSubheadline';
import HeroButton from './HeroButton';
import HeroGraphic from './HeroGraphic';

interface HeroContentProps {
  onGetStarted: () => void;
}

export default function HeroContent({ onGetStarted }: HeroContentProps) {
  return (
    <HeroContentLayout>
      <motion.div 
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center lg:text-left lg:flex-1"
      >
        <HeroHeadline />
        
        <div className="block lg:hidden mt-8 mb-8">
          <HeroGraphic />
        </div>
        
        <HeroSubheadline />
        <HeroButton onClick={onGetStarted} />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="hidden lg:flex lg:flex-1 lg:items-center h-full"
      >
        <HeroGraphic />
      </motion.div>
    </HeroContentLayout>
  );
}